<template>
  <div id="member">
    <div class="head">
      <div class="left">
        <el-button
          type="primary"
          icon="Plus"
          @click="dialogVisible = true"
          v-grantShow="$store.state.SysGrant.AddAccount"
          >添加用户</el-button
        >
        <el-button
          type="danger"
          icon="Delete"
          plain
          @click="memberDel(checkedData, 'all')"
          v-grantShow="$store.state.SysGrant.DelAccount"
          >删除用户</el-button
        >
      </div>

      <div class="right">
        <el-select v-model="level" placeholder="请选择用户级别" clearable>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="screenValue"
          placeholder="请输入搜索内容"
          class="input-with-select"
          :clearable="true"
        >
          <template #append>
            <el-button icon="Search" @click="memberGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="screenChecked"
              placeholder="请选择"
              style="width: 100px"
            >
              <el-option
                v-for="item in screenData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
        <!-- <el-input
          v-model="screenValue"
          placeholder="请输入搜索内容"
          prefix-icon="Search"
        />
        <el-select v-model="screenChecked" placeholder="请选择">
          <el-option
            v-for="item in screenData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
        <el-icon v-if="type == 'grid'" @click="type = 'table'"
          ><Grid
        /></el-icon>
        <el-icon v-else-if="type == 'table'" @click="type = 'grid'"
          ><List
        /></el-icon>
      </div>
    </div>

    <div class="body">
      <el-dialog
        v-model="dialogVisible"
        :title="form.id ? `编辑用户 - ${form.id}` : '添加用户'"
        :width="$store.state.screenWidth > 1200 ? '450px' : '98%'"
        align-center
        @closed="dialogClosed"
        :close-on-click-modal="false"
      >
        <el-form :model="form" ref="formRef" label-position="top">
          <el-form-item
            label="账号"
            label-width="85px"
            prop="name"
            :rules="[
              {
                required: true,
                message: '账号不能为空',
                trigger: 'change',
              },
              {
                validator: nameValidator,
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              :disabled="form.id ? true : false"
              v-model.trim="form.name"
              autocomplete="off"
              placeholder="请输入账号"
            />
          </el-form-item>

          <el-form-item
            label="密码"
            label-width="85px"
            prop="passwd"
            :rules="
              form.id
                ? []
                : [
                    {
                      required: true,
                      message: '密码不能为空',
                      trigger: 'change',
                    },
                  ]
            "
          >
            <el-input
              v-model.trim="form.passwd"
              autocomplete="off"
              :placeholder="form.id ? '不更改密码，不用填写' : '请输入密码'"
            />
          </el-form-item>

          <el-form-item
            label="角色"
            label-width="85px"
            prop="level"
            :rules="[
              {
                required: true,
                message: '角色不能为空',
                trigger: 'change',
              },
            ]"
          >
            <el-select v-model="form.level" placeholder="请选择角色级别">
              <el-option
                v-for="item in levelData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            label="用户姓名"
            label-width="85px"
            prop="realname"
            :rules="[
              {
                required: true,
                message: '用户姓名不能为空',
                trigger: 'change',
              },
            ]"
          >
            <el-input
              v-model.trim="form.realname"
              autocomplete="off"
              placeholder="请输入用户姓名"
            />
          </el-form-item>

          <el-form-item label="用户备注" label-width="85px">
            <el-input
              v-model="form.remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              type="textarea"
              maxlength="30"
              show-word-limit
              placeholder="请输入用户备注"
            />
          </el-form-item>

          <div
            class="state"
            style="width: 100%; display: flex; align-items: center"
          >
            <span class="title" style="font-weight: 500; margin-right: 8px"
              >用户状态</span
            >
            <el-switch
              v-model="form.state"
              :active-value="1"
              :inactive-value="0"
            />
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="create">确定</el-button>
          </span>
        </template>
      </el-dialog>

      <el-empty
        v-show="memberList.length == 0 && type == 'grid'"
        :image="require('@/assets/images/empty.png')"
        description="暂无用户,请添加用户"
        style="--el-empty-padding: 120px 0"
      ></el-empty>

      <div class="grid" v-show="type == 'grid'">
        <div
          :class="
            'item' +
            (checkedData.findIndex((item2) => item.id == item2) != -1
              ? ' index'
              : '')
          "
          v-for="item in memberList"
          :key="item.id"
        >
          <div
            class="img"
            :style="`background-color: ${
              item.color && colorMap[item.color]
                ? colorMap[item.color].color
                : '#000'
            }`"
          >
            {{ item.realname[0] }}
          </div>
          <h3>{{ item.realname }}</h3>
          <!-- <p>{{ item.username }}</p> -->
          <div class="copy">
            <el-icon><Avatar /></el-icon>
            <span>{{ item.name }}</span>
          </div>
          <el-tag
            :style="`--el-tag-text-color:${
              item.color && colorMap[item.color]
                ? colorMap[item.color].color
                : '#000'
            };--el-tag-border-color:${
              item.color && colorMap[item.color]
                ? colorMap[item.color].color
                : '#000'
            };font-weight: bold;`"
            effect="plain"
            round
          >
            {{ item.username }}
          </el-tag>

          <el-dropdown placement="bottom-end" trigger="click">
            <el-icon @click.stop class="more"><MoreFilled /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  @click="memberEdit(item)"
                  v-grantShow="$store.state.SysGrant.AddAccount"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  @click="memberDel(item.id)"
                  v-grantShow="$store.state.SysGrant.DelAccount"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <el-icon class="checked" @click="memberChecked(item.id)"
            ><Select
          /></el-icon>
        </div>
      </div>

      <div class="table" v-show="type == 'table'">
        <el-table
          ref="tableRef"
          :data="memberList"
          tooltip-effect="dark"
          row-key="id"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#F4F7FB' }"
          :header-row-style="{ backgroundColor: '#F4F7FB', color: '#1E2026' }"
          @selection-change="handleSelectionChange"
        >
          <!-- @sort-change="sort" -->
          <el-table-column
            type="selection"
            :width="$store.state.screenWidth > 1200 ? 55 : 30"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column
            label="ID"
            :width="$store.state.screenWidth > 1200 ? 'auto' : 50"
            prop="id"
          ></el-table-column>
          <el-table-column
            label="用户信息"
            width="auto"
            class-name="userInfo"
            :min-width="$store.state.screenWidth > 1200 ? 200 : 180"
          >
            <template #default="scope">
              <span
                class="icon"
                :style="`background-color: ${
                  scope.row.color && colorMap[scope.row.color]
                    ? colorMap[scope.row.color].color
                    : '#000'
                }`"
                >{{ scope.row.realname[0] }}</span
              >
              <div class="info">
                <div class="name">{{ scope.row.realname }}</div>
                <div class="id">{{ scope.row.username }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="账号"
            width="200"
          ></el-table-column>
          <el-table-column label="登录信息" min-width="250">
            <template #default="scope">
              <div>{{ scope.row.logingeo }}：{{ scope.row.loginip }}</div>
              <div>
                登录时间：{{
                  $moment(scope.row.logintime * 1000).format(
                    "yyyy-MM-DD HH:mm:ss"
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="角色" class-name="role">
            <template #header>
              <span :style="command2 !== '' ? 'color:#059669;' : ''">角色</span>
              <el-dropdown
                trigger="click"
                popper-class="dropdown"
                @command="handleCommand2"
                max-height="200px"
                v-if="false"
              >
                <el-icon><ArrowDown /></el-icon>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      command=""
                      :class="command2 === '' ? 'index' : ''"
                      >全部</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-for="item in roleData"
                      :key="item.id"
                      :command="item.id"
                      :class="command2 === item.id ? 'index' : ''"
                      >{{ item.name }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </template>
              </el-dropdown></template
            >
            <template #default="scope">
              <el-tag
                :style="`--el-tag-bg-color:${
                  scope.row.color && colorMap[scope.row.color]
                    ? colorMap[scope.row.color].color
                    : '#000'
                };--el-tag-border-color:${
                  scope.row.color && colorMap[scope.row.color]
                    ? colorMap[scope.row.color].color
                    : '#000'
                };font-weight: bold;`"
                effect="dark"
                round
              >
                {{ scope.row.username }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="显示" width="auto" class-name="screen">
            <template #header>
              <span :style="command !== '' ? 'color:#059669;' : ''">显示</span>
              <el-dropdown
                trigger="click"
                popper-class="dropdown"
                @command="handleCommand"
              >
                <el-icon><ArrowDown /></el-icon>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      command=""
                      :class="command === '' ? 'index' : ''"
                      >全部</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="1"
                      :class="command === 1 ? 'index' : ''"
                      >显示</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="0"
                      :class="command === 0 ? 'index' : ''"
                      >不显示</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </template>
              </el-dropdown></template
            >
            <template #default="scope">
              <el-switch
                v-model="scope.row.state"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange(scope.row.state, scope.row.id)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            :min-width="$store.state.screenWidth > 1200 ? '150px' : 120"
          >
            <template #default="scope">
              <el-button
                type="primary"
                link
                @click="memberEdit(scope.row)"
                v-grantShow="$store.state.SysGrant.AddAccount"
                >编辑</el-button
              >
              <el-divider
                direction="vertical"
                v-grantShow="$store.state.SysGrant.DelAccount"
              ></el-divider>
              <el-button
                type="primary"
                link
                @click="memberDel(scope.row.id)"
                v-grantShow="$store.state.SysGrant.DelAccount"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-pagination
        background
        :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
        layout="prev, pager, next"
        v-model:current-page="page"
        :total="tableCount"
      />
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  onMounted,
  getCurrentInstance,
  ref,
  computed,
  watch,
  onActivated,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import md5 from "js-md5";
export default {
  name: "hotel",
  setup() {
    let vuex = useStore();
    //获取公共方法
    let { proxy } = getCurrentInstance();
    let data = reactive({
      memberList: [],
      type: "grid",
      checkedData: [],
      //弹窗显示隐藏
      dialogVisible: false,
      //用户组级别数据
      options: [
        {
          value: 10,
          label: "一级用户",
        },
        {
          value: 20,
          label: "二级用户",
        },
        {
          value: 30,
          label: "三级用户",
        },
        {
          value: 40,
          label: "四级用户",
        },
        {
          value: 50,
          label: "五级用户",
        },
        {
          value: 60,
          label: "六级用户",
        },
        {
          value: 70,
          label: "七级用户",
        },
        {
          value: 80,
          label: "八级用户",
        },
        {
          value: 90,
          label: "九级用户",
        },
      ],
      //级别用户下标
      level: "",
      //颜色数据
      colorMap: {
        1: {
          id: 1,
          color: "#059669",
        },
        2: {
          id: 2,
          color: "#34D399",
        },
        3: {
          id: 3,
          color: "#2FD0DA",
        },
        4: {
          id: 4,
          color: "#8B5DF1",
        },
        5: {
          id: 5,
          color: "#FF6DAB",
        },
        6: {
          id: 6,
          color: "#FB3030",
        },
        7: {
          id: 7,
          color: "#FFB200",
        },
        8: {
          id: 8,
          color: "#FC8A32",
        },
        9: {
          id: 9,
          color: "#77829A",
        },
      },
      //筛选数据
      screenData: [
        {
          label: "账号",
          value: "name",
        },
        {
          label: "用户名称",
          value: "realname",
        },
      ],
      //筛选内容
      screenValue: "",
      //筛选类型
      screenChecked: "name",
      //新增相册表单数据
      form: {
        name: "",
        passwd: "",
        realname: "",
        level: "",
        remark: "",
        work_types: [],
        state: 1,
      },
      formRef: ref(null),
      //角色列表数据
      levelData: [],
      //显示筛选
      command: "",
      //表格ref对象
      tableRef: ref(null),
      //角色列表数据
      roleData: [],
      //角色筛选
      command2: "",
      //页数
      page: 1,
      //表格总数
      tableCount: 0,
    });

    //页面激活后
    onActivated(() => {
      memberGet();
      groupGet();
    });

    //监听工单职位变化
    watch(
      () => data.form.level,
      (newValue, oldValue) => {}
    );
    //监听筛选内容变化
    watch([() => data.screenValue, () => data.level], (newValue, oldValue) => {
      if (data.page == 1) {
        search();
      } else {
        data.page = 1;
      }
    });
    //监听筛选下拉框变化
    watch(
      () => data.screenChecked,
      (newValue, oldValue) => {
        if (data.page == 1) {
          memberGet();
        } else {
          data.page = 1;
        }
      }
    );
    //监听页数变化
    watch(
      () => data.page,
      (newValue, oldValue) => {
        memberGet();
      }
    );
    //监听类型变化
    watch(
      () => data.type,
      (newValue, oldValue) => {
        if (newValue == "table") {
          let checkData = JSON.parse(JSON.stringify(data.checkedData));
          data.memberList.forEach((item) => {
            data.tableRef.toggleRowSelection(
              item,
              checkData.findIndex((item2) => {
                return item.id == item2;
              }) != -1
            );
          });
        } else if (newValue == "grid") {
          (data.command = ""), (data.command2 = ""), memberGet();
        }
      }
    );

    //获取成员列表接口
    let memberGet = () => {
      let obj = {};
      if (data.screenChecked) {
        obj[data.screenChecked] = data.screenValue;
      }
      if (data.command !== "") {
        obj.state = data.command;
      }
      if (data.command2 !== "") {
        obj.level = data.command2;
      }
      if (data.level) {
        obj.level = data.level;
      }

      //获取所在门店权限接口
      proxy.$http
        .get("webapi/account_mgr", {
          params: {
            hotel_id: vuex.state.id,
            item: "list",
            orderby: "id|1",
            page: data.page,
            ...obj,
          },
        })
        .then(({ data: res }) => {
          let groups = res.data.groups;
          let list = res.data.list;
          // let users = res.data.users;
          list.forEach((item) => {
            groups.forEach((item2) => {
              if (item.level == item2.level) {
                item.color = item2.color;
                item.username = item2.name;
              }
            });
            // users.forEach((item2) => {
            //   if (item.aid == item2.id) {
            //     item.username = item2.name;
            //   }
            // });
          });
          data.tableCount = res.data.count;
          data.memberList = list;
        })
        .catch((err) => {
          console.log("请求失败", err);
        });
    };
    //获取角色列表
    let groupGet = () => {
      proxy.$http
        .get("webapi/group_mgr", {
          params: {
            hotel_id: vuex.state.id,
            item: "names",
            orderby: "id|0",
          },
        })
        .then(({ data: res }) => {
          data.roleData = res.data.list;
          data.levelData = res.data.list.map((item) => {
            return {
              value: item.level,
              label: item.name,
            };
          });
        })
        .catch((err) => {
          console.log("请求失败");
        });
    };
    //添加用户
    let create = () => {
      data.formRef.validate((valid, err) => {
        if (valid) {
          let req = JSON.parse(JSON.stringify(data.form));
          req.work_types = req.work_types.join(",");
          if (req.passwd) {
            req.passwd = md5("mq" + req.name + req.passwd);
          } else {
            delete req.name;
            delete req.passwd;
          }
          proxy.$http
            .post("webapi/account_mgr", {
              hotel_id: vuex.state.id,
              ...req,
              item: req.id ? "set" : "add",
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                ElMessage({
                  message: `${req.id ? "编辑" : "添加"}成功！`,
                  type: "success",
                });
              } else {
                ElMessage({
                  message: `${req.id ? "编辑" : "添加"}失败！`,
                  type: "error",
                });
              }
              data.dialogVisible = false;
              memberGet();
            })
            .catch((err) => {
              console.log(`${req.id ? "编辑" : "添加"}失败`);
            });
        } else {
          return false;
        }
      });
    };
    //删除用户
    let memberDel = (id, type) => {
      if (type == "all") {
        if (id.length != 0) {
          id = id.join(",");
        } else {
          ElMessage({
            message: "请选择要删除的用户！",
            type: "warning",
          });
          return;
        }
      }
      ElMessageBox.confirm(
        `此操作将永久删除${type == "all" ? "选中" : "该"}用户, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          proxy.$http
            .post("webapi/account_mgr", {
              id,
              hotel_id: vuex.state.id,
              item: "del",
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                ElMessage({
                  message: "删除成功！",
                  type: "success",
                });
                memberGet();
              } else {
                ElMessage({
                  message: "删除失败！",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    };
    //弹窗关闭回调
    let dialogClosed = () => {
      data.form = {
        name: "",
        passwd: "",
        realname: "",
        level: "",
        remark: "",
        work_types: [],
        state: 1,
      };
      data.formRef.resetFields();
    };
    //用户编辑
    let memberEdit = (obj) => {
      data.form = {
        id: obj.id,
        name: obj.name,
        passwd: "",
        realname: obj.realname,
        level: obj.level,
        remark: obj.remark,
        work_types: obj.work_types
          ? obj.work_types.split(",").map((item) => +item)
          : [],
        state: obj.state,
      };
      data.dialogVisible = true;
    };
    //更改用户状态
    let switchChange = (state, id) => {
      proxy.$http
        .post("webapi/account_mgr", {
          hotel_id: vuex.state.id,
          id,
          state,
          item: "set",
        })
        .then(({ data: res }) => {
          memberGet();
        })
        .catch((err) => {
          console.log(`编辑失败`);
        });
    };
    //表格多选
    let handleSelectionChange = (value) => {
      console.log(value);
      data.checkedData = value.map((item) => item.id);
    };
    //表格显示筛选项
    let handleCommand = (value) => {
      data.command = value;
      memberGet();
    };
    //表格角色筛选项
    let handleCommand2 = (value) => {
      data.command2 = value;
      memberGet();
    };
    //表格角色选中
    let memberChecked = (id) => {
      let index = data.checkedData.findIndex((item) => {
        return item == id;
      });
      if (index == -1) {
        data.checkedData.push(id);
      } else {
        data.checkedData.splice(index, 1);
      }
    };
    //账号正则校验
    let nameValidator = (rule, value, callback) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    //用户权限状态
    let grantsState = (permissions) => {
      let grants = vuex.state.pages.grants;
      if (grants == "*") {
        return true;
      } else {
        grants = grants.split(",");
        return grants.find((item) => item == permissions);
      }
    };

    let search = proxy.$dataConver.debounce(100, memberGet);

    return {
      ...toRefs(data),
      create,
      memberDel,
      dialogClosed,
      memberEdit,
      switchChange,
      handleSelectionChange,
      handleCommand,
      memberChecked,
      handleCommand2,
      nameValidator,
      grantsState,
      memberGet,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/hotel/member.scss";
</style>
